/*
 * VatomInc. Copyright (c) 2022, all rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in the root directory of this source tree.
 */
import { ARViewerWeb } from '.'

/** Responsible for monitoring the geolocation, and notifying other plugins when it changes */
export default class GeolocationPlugin {
  ar: ARViewerWeb

  constructor(ar: ARViewerWeb) {
    // Store AR
    this.ar = ar
  }

  get name() {
    return 'GeolocationPlugin'
  }

  async load(div: HTMLDivElement) {
    // Do location update
    return this.updateLocation()
  }

  /** Fetch new location and notify other plugins */
  async updateLocation() {
    // Stop if no support
    if (!navigator.geolocation) throw new Error('This browser does not support geolocation.')

    // Show status
    this.ar.setState({ loadingText: 'Fetching GPS coordinates...' })

    // Fetch current position
    const data: GeolocationPosition = await new Promise((resolve, reject) =>
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        // Geolocation fetch settings
        maximumAge: Infinity,
        timeout: 30000,
        enableHighAccuracy: true
      })
    )

    // Got position!
    this.ar.currentGeolocation = data.coords

    // Update user's profile with the latest location
    // await VatomInc.updateLocation(data.coords);
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  unload() {}
}
